<cc-ng1-custom-phone-number [msisdn]="msisdn"
                            [plan]="plan"
                            *ngIf="msisdn"></cc-ng1-custom-phone-number>
